import React from "react";
import "./footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter } from "react-icons/fa";

export default function FooterSection() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        {/* Top Links */}
        <div className="footer-top">
          <ul className="footer-links">
            <li><a href="about">About Us</a></li>
            <li><a href="contact">Contact Us</a></li>
            <li><a href="pricing">Fees</a></li>
          </ul>

          <ul className="footer-socials">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
            </li>
          </ul>
        </div>

        <hr />

        {/* Bottom Info */}
        <div className="footer-bottom">
          <p>Copyright © 2025 OMESWARA FINTECH PRIVATE LIMITED. All Rights Reserved.</p>
          <ul className="footer-policies">
            <li><a href="terms">Terms</a></li>
            <li><a href="privacy">Privacy</a></li>
            <li><a href="refund">Refund Policy</a></li>
          </ul>
        </div>

        {/* Scroll to Top Button */}
        {/* <button className="scroll-top-btn" onClick={scrollToTop}>
          <FaArrowUp />
        </button> */}
      </div>
    </footer>
  );
}
